// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"770":"routes","995":"collects-create"}[chunkId] + "." + {"770":"94895545","995":"584793a5"}[chunkId] + ".css";
};